import { get } from 'lodash';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { validationClasses } from '@/utils/errors';
import parseDate, { formatDateForState } from '@/utils/dateHelper';
import { camelConverter } from '../helper';

const FormDate = ({
  autoFocus,
  disabled,
  error,
  field,
  onChange,
  text,
}) => (
  <DatePicker
    autoComplete="off"
    autoFocus={autoFocus}
    className={validationClasses(error, 'aridhia-form-date')}
    dateFormat="dd/MMM/yyyy"
    disabled={disabled}
    dropdownMode="select"
    fixedHeight
    maxDate={parseDate(get(field, 'validation.maximum'))}
    minDate={parseDate(get(field, 'validation.minimum'))}
    name={camelConverter(field.name, '_')}
    onChange={(value) => onChange(formatDateForState(value))}
    placeholderText={field.placeholder}
    selected={parseDate(text)}
    showMonthDropdown
    showYearDropdown
  />
);

export default FormDate;
